<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                    <SummeryCnt v-bind:scnt1=scnt1 v-bind:scnt2=scnt2  v-bind:scnt3=scnt3  v-bind:scnt4=scnt4 
                    v-bind:summeryTtile=summeryTtile  v-bind:summeryTtile1=summeryTtile1  v-bind:summeryTtile2=summeryTtile2  v-bind:summeryTtile3=summeryTtile3 v-bind:summeryTtile4=summeryTtile4  />
                    <v-card elevation="1" class="mt-3" >
                        <div class="d-flex pt-3" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Registration Date</div>
                            <div class="d-flex pr-5" style="width:100%;">
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu 
                                        ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        :return-value.sync="s_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="150px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field 
                                            v-model="s_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="d-flex align-self-center mt-0 pt-0"
                                            style="font-size:13px; "
                                            placeholder="Start Date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="s_date" no-title scrollable :max="e_date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="s_date_search(s_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu
                                        ref="menu2"
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :return-value.sync="e_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="220px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            v-model="e_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="align-self-center ma-0 pa-0"
                                            style="font-size:13px;width:190px;"
                                            placeholder="End Date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="e_date" no-title scrollable :min="s_date" :max="date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="e_date_search(e_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="d-flex" >
                                    <v-btn-toggle v-model="toggleMonthBtn" class="pt-4">
                                        <v-btn small class="ml-1" @click="setSchDate(1)">Today</v-btn>
                                        <v-btn small  @click="setSchDate(2)">1 Month</v-btn>
                                        <v-btn small  @click="setSchDate(3)">All</v-btn>
                                    </v-btn-toggle>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Classification</div>
                            <div class="d-flex pr-5" style="width:100%;">
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schCountryCode" :items="countryList" item-text="info" item-value="vals" label="National" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                                <div class="d-flex pr-5" style="width:200px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schRsvStatus" :items="statusList" item-text="info" item-value="vals" label="Status" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Keyword</div>
                            <div class="d-flex" style="width:100%;">
                                <div class="d-flex pt-2 pr-auto" style="width:557px;">
                                    <v-text-field v-model="schText" outlined dense single-line hide-details small placeholder="MemberID(Name) / Vehicle Identification Number / Charger Station / Charger ID / Battery ID"></v-text-field>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex pb-5 justify-center" style="width:100%;">
                            <v-btn class="schClearBtn" small dark @click="searchFormReset()">Clear </v-btn>
                            <v-btn class="ml-2 schBtn" small dark @click="getList()">Search</v-btn>
                        </div>
                    </v-card>
                    <v-card elevation="1" class="mt-3">
                        <div class="d-flex flat pa-5" elevation="0" >
                            <div class="mr-auto align-self-center font-weight-bold text-subtitle-1" >Total <span class="listCnt">{{listTotalCnt}}</span></div>
                            <div class="pr-2">
                                <!-- 예약상태(1:대기, 2:예약완료, 3:예약취소, 4:교환완료) -->
                                <v-btn color="red" small outlined class="ml-2" @click="setAprvStatus('3')">Reserve Cancel</v-btn>
                                <!--<v-btn color="teal" small  outlined class="ml-2" @click="setAprvStatus('2')">Reserve Complete</v-btn>-->
                                <v-btn color="indigo" small  outlined  class="ml-2" @click="setAprvStatus('5')">Rental</v-btn>
                            </div>
                        </div>
                        <div>
                            <table style="width:100%;" cellspacing="0" cellpadding="0" class="px-5">
                                <tr class="listHeader">
                                    <th style="width:20px"><v-checkbox class="align-self-center pl-2 ma-0" hide-details color="white" dark @click="checkedAll" v-model="allSelected"></v-checkbox></th>
                                    <th style="width:40px">No</th>
                                    <th style="width:15%">ID</th>
                                    <th style="width:8%">Name</th>
                                    <th style="width:12%">Vehicle Identification Number</th>
                                    <th>Charger Station</th>
                                    <th>Charger ID</th>
                                    <th>Battery ID</th>
                                    <th style="width:12%">Status</th>
                                    <th style="width:10%">Registration Date</th>
                                </tr>
                                <tr v-for="(item, index) in ebikeList" :key="item.RSV_SEQ">
                                    <td class="rowList"><v-checkbox v-model="selectEbkSeq" class="align-self-center pl-2 ma-0" hide-details  :value=item.RSV_SEQ @click="selected()"></v-checkbox></td>
                                    <td class="rowList">{{(listTotalCnt - (page -1) * 10) - index}}</td>
                                    
                                    <td class="rowList">{{item.USR_ID}}</td>
                                    <td class="rowList">{{item.USR_NM}}</td>
                                    <td class="rowList">{{item.VC_IDTFY_NUMS}}</td>
                                    <td class="rowList"><span style="color:#1976D2;cursor:pointer;" @click="viewInfo(item.RSV_SEQ)">{{item.BSS_NM}}</span></td>
                                    <td class="rowList">{{item.CHG_BSS_CHGR_ID}}</td>
                                    <td class="rowList">{{item.CHG_BSS_CELL_ID1}} / {{item.CHG_BSS_CELL_ID2}}</td>
                                    <td class="rowList">{{item.RSV_INFO}}</td>
                                    <td class="rowList">{{item.INS_DTM}}</td>
                                </tr>
                                <tr v-if="emptyFlag=='Y'">
                                    <td colspan="10" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </table>
                            <div class="pa2" v-if="listTotalCnt>0">
                                <div class="text-center mt-5">
                                    <!--
                                    <v-pagination v-model="page" :length="pagelength" @input="getPageList"></v-pagination>
                                    -->
                                     <Paging :currentPage="page" :totalPages="pagelength" :key="listTotalCnt" :totalCount="listTotalCnt" @onPageChange="onPageChange" />
                                </div>
                            </div>
                            <div class="d-flex justify-space-between dense pa-5">
                                <div class="pa2 pl-2 " ><v-btn class="excelBtn" dark @click="downExcel">Excel Download</v-btn></div>
                                <div class="pa2 pr-2">
                                    <!-- <v-btn color="green lighten-2" small dark class="ml-2">Excel Registration</v-btn> -->
                                    <!-- <v-btn color="primary" small dark class="ml-2" @click="registerVehicle">New Registration</v-btn> -->
                                </div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

        <!-- alert: not checked -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="chkListFlag" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:red;'>mdi-alert </v-icon>
                        <span class="pl-3">Please select a list of reserve </span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="chkListFlag = false">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        
        <!--<ErrorDialog v-on:childEvent="closeErrorDialog" />-->

        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="closeDialog('Success')">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="closeDialog('Error')">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    /*.theme--light.v-btn.v-btn--has-bg {background-color: #1e2c3c !important; color:#fff}*/
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import SummeryCnt from '@/components/summeryCnt.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'
import Paging from '@/components/paging.vue'

import dayjs from 'dayjs'

export default {
    name: 'Deivce',
    components: { Gnb, Footer, SummeryCnt, Navs, PageCrumbs,  Paging },

    data () {
        return {
            // login Info
            gnbCode:"4", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:11, 
            // Page Title & Breadcrumbs
            pTitles: "Reservation List",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Reserve', disabled: true,}, { text: 'Reservation Management', disabled: true,}, { text: 'Reservation List', disabled: false,}],
            NavList: [ 
                        { title: 'Reserve', nums: '1',
                            items: [ { title: 'Reservation Management', nums:11, href:'/Reserve', icons:'mdi-format-list-bulleted' }],
                        },
                       
                    ],     

            // Summery title & Count
            scnt1:"0", scnt2:"0", scnt3:"0", scnt4:"0", summeryTtile:"등록현황", summeryTtile1:"Total", summeryTtile2:"Exchange", summeryTtile3:"Reserve", summeryTtile4:"Cancel",
            // List count & Pagination 
            listTotalCnt: 0, page: 0, pagelength:0, ebikeList:[],
            emptyFlag: 'Y',
            // Datepicker & Short button
            date: new Date().toISOString().substr(0, 10), 
            s_date: "", e_date: "", menu1: false, menu2: false,
            toggleMonthBtn:2,

            // Search form : select 
            countryList: [{info: 'Indonesia', vals: "ID"}, {info: 'korea', vals: "KR"}],
            statusList:[{info: 'Reserve Completed', vals: 2}, {info: 'Reserve Canceled', vals: 3}, {info: 'Exchange Completed', vals: 4}, {info: 'Exchanging', vals: 5}],
            schCountryCode: "", schText:"", schRsvStatus:"",
            
            // Checkbox
            selectEbkSeq:[], allSelected: false,
            // Async & Modify Result
            chkListFlag : false,  asyncErrors: false, asyncSuccess: false,
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        this.page = 1;
        this.getList(this.page);
        localStorage.removeItem("schRsvSeq");
    },

    methods : {
        // datepicker 
        setSchDate(arg) {
            if(arg == 1) {
                this.s_date = new Date().toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 2) {
                let now = new Date();
                this.s_date =  new Date(now.setMonth(now.getMonth() - 1));
                this.s_date = this.s_date.toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 3) {
                this.s_date = '';
                this.e_date = '';
            }
        },

        // datepicker - sub
        s_date_search(v) {
            this.s_date = v;
            this.menu1 = false;
            this.$refs.menu1.save(v);
        },

        // datepicker - sub
        e_date_search(v) {
            this.e_date = v;
            this.menu2 = false;
            this.$refs.menu2.save(v);
        },

        // search form reset
        searchFormReset() {
            this.s_date=""; this.e_date="";
            this.schCountryCode=""; this.schRsvStatus=""; this.schText="";
            this.page = 1;
            this.getList(this.page);
        },

        getPageList() {
            //console.log(this.page);
            this.getList(this.page);
        },

        // API Async 
        getList(page) {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L"
                    , "page":page
                    , "schRsvStatus": this.schRsvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                })
            };
            /*
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L"
                    , "page":page
                    , "schRsvStatus": this.schRsvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                }));
            */
            fetch('https://api.e3bss.com/_APP/POC/reserveInfo.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json );
                //console.log(json.value.list );
                if(json.result == "success") {
                    this.ebikeList =[];
                    this.ebikeList = json.value.list;
                    this.listTotalCnt = Number(json.totalCnt);
                    this.pagelength = json.totalPage;
                    this.emptyFlag = "N";
                    this.page = json.currentPage;
                } else {
                    this.ebikeList = [];
                    this.emptyFlag = "Y";
                    this.listTotalCnt = 0;
                }
                this.scnt1 = json.cnt1; this.scnt2 = json.cnt2; this.scnt3 = json.cnt3; this.scnt4 = json.cnt4;
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        // Approve Status Modify
        setAprvStatus(vals) {
            //console.log(this.selectEbkSeq.length + "/"+ this.selectEbkSeq);
            if(vals != '' && this.selectEbkSeq.length > 0) {
                this.chkListFlag = false;
                this.modifyApprove(vals);
            } else {
                this.chkListFlag = true;
            }
        },

        // API Async: Status Update
        modifyApprove(arg) {
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "LU"
                    , "rsvSeqArr": this.selectEbkSeq
                    , "rsvStatus": arg
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/reserveInfo.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                if(json.result == "success") {
                    this.getList(1);
                    this.asyncSuccess = true;
                    this.asyncErrors = false;
                } else {
                    this.asyncSuccess = false;
                    this.asyncErrors = true;
                }
            }).catch(() => {
                this.asyncErrors = true;
                //console.log(error);
            });
        }, 
        
        viewInfo(arg) {
            //console.log(arg);
            localStorage.setItem("schRsvSeq", arg);
            this.$router.push({ name: 'ReserveDetail', params: { Seq: arg }})
        },

        checkedAll() {
            //console.log('click');
            this.selectEbkSeq = [];
            if (this.allSelected) {
                for (let ebkies in this.ebikeList) {
                    this.selectEbkSeq.push(this.ebikeList[ebkies].RSV_SEQ.toString());
                }
            }
        },

        selected: function() {
            this.allSelected = false;
        }, 
        
        closeDialog(cls) {
            if(cls == "Success") {
                this.asyncSuccess = false;
            } else if(cls == "Error") {
                this.asyncErrors = false;
            }
            this.selectEbkSeq = [];
            this.allSelected=false;
        },
        
        onPageChange(param) {
            //console.log("onPageChange="+param);
            this.page = Number(param);
            //console.log("this.page="+Number(this.page));
            this.getList(this.page);
        },
        downExcel() {
            const xlsx = require("xlsx");
            // 엑셀 파일 생성
            const sheets = xlsx.utils.book_new();
            // data get > 실 개발시 api 호출
            
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "EL"
                    , "schRsvStatus": this.schRsvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                })
            };
            /*
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode":this.loginInfo3
                    , "act": "EL"
                    , "schAprvStatus": this.schAprvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schFactoryCode": this.schfactoryCode
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                }));
            */
            fetch('https://api.e3bss.com/_APP/POC/reserveInfo.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                //console.log(json );
                //console.log(json.list );
                if(json.result == "success") {
                    const excelData = json.value.list;
                    const worksheetData = xlsx.utils.json_to_sheet(excelData);
                    xlsx.utils.book_append_sheet(sheets, worksheetData, "Data");
                    let nowDTM =  dayjs().format("YYYYMMDDHHmmss");
                    xlsx.writeFile(sheets, "reserveList_"+nowDTM+".xlsx");
                } else {
                   //alert("Error");
                   this.$router.replace('Error');
                }
                
            }).catch((error) => {
                console.log(error);
                this.$router.replace('Error');
            });
           
        },

    }

}
</script>
